module.exports = __webpack_public_path__ + "images/corporate-training-banner.webp";